import { render, staticRenderFns } from "./reserve-dialog.vue?vue&type=template&id=b06bd040&scoped=true&lang=pug&"
import script from "./reserve-dialog.vue?vue&type=script&lang=js&"
export * from "./reserve-dialog.vue?vue&type=script&lang=js&"
import style0 from "./reserve-dialog.vue?vue&type=style&index=0&id=b06bd040&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06bd040",
  null
  
)

export default component.exports